import React from 'react';
import { string, node } from 'prop-types';

export const Success = ({ children, className }) => <span className={`u__text--success ${className}`}>{children}</span>;

Success.displayname = 'Success';

Success.propTypes = {
  children: node,
  className: string,
};

Success.defaultProps = {
  children: null,
  className: '',
};
